// extracted by mini-css-extract-plugin
export var button = "_6g-4";
export var hasDarkBackground = "_6g-7";
export var hasLightBackground = "_6g-6";
export var iconWrapper = "_6g-0";
export var large = "_6g-2";
export var medium = "_6g-1";
export var small = "_6g-5";
export var xsmall = "_6g-3";